import { Temporal } from '@js-temporal/polyfill'

const timeZone = 'Europe/Oslo'

const dynamicClosedDays = [
  {
    text: 'Maundy Thursday',
    date: Temporal.ZonedDateTime.from({
      year: 2025,
      month: 4,
      day: 17,
      timeZone
    }).toInstant()
  },
  {
    text: 'Good Friday',
    date: Temporal.ZonedDateTime.from({
      year: 2025,
      month: 4,
      day: 18,
      timeZone
    }).toInstant()
  },
  {
    text: 'Easter Monday',
    date: Temporal.ZonedDateTime.from({
      year: 2025,
      month: 4,
      day: 21,
      timeZone
    }).toInstant()
  },
  {
    text: 'Ascension Day',
    date: Temporal.ZonedDateTime.from({
      year: 2025,
      month: 5,
      day: 29,
      timeZone
    }).toInstant()
  },
  {
    text: 'Whit Monday',
    date: Temporal.ZonedDateTime.from({
      year: 2025,
      month: 6,
      day: 9,
      timeZone
    }).toInstant()
  }
]

export const closedDays = [
  // New Year's Day
  {
    text: "New Year's Day",
    date: Temporal.ZonedDateTime.from({
      year: 2025,
      month: 1,
      day: 1,
      timeZone
    }).toInstant()
  },
  // Labor Day
  {
    text: 'Labor Day',
    date: Temporal.ZonedDateTime.from({
      year: 2025,
      month: 5,
      day: 1,
      timeZone
    }).toInstant()
  },
  // Constitution Day
  {
    text: 'Constitution Day',
    date: Temporal.ZonedDateTime.from({
      year: 2025,
      month: 5,
      day: 17,
      timeZone
    }).toInstant()
  },
  // Christmas Eve
  {
    text: 'Christmas Eve',
    date: Temporal.ZonedDateTime.from({
      year: 2025,
      month: 12,
      day: 24,
      timeZone
    }).toInstant()
  },
  // Christmas Day
  {
    text: 'Christmas Day',
    date: Temporal.ZonedDateTime.from({
      year: 2025,
      month: 12,
      day: 25,
      timeZone
    }).toInstant()
  },
  // Boxing Day
  {
    text: 'Boxing Day',
    date: Temporal.ZonedDateTime.from({
      year: 2025,
      month: 12,
      day: 26,
      timeZone
    }).toInstant()
  },
  // New Year's Eve
  {
    text: "New Year's Eve",
    date: Temporal.ZonedDateTime.from({
      year: 2025,
      month: 12,
      day: 31,
      timeZone
    }).toInstant()
  },
  ...dynamicClosedDays
]

export function isClosedDay(date: Temporal.ZonedDateTime) {
  // Check if it's a weekend (Saturday = 6, Sunday = 7)
  const dayOfWeek = date.dayOfWeek
  if (dayOfWeek === 6 || dayOfWeek === 7) {
    // If it's a weekend, it's a closed day.
    return true
  }

  // Check against the closed days list
  return closedDays.some((day) => {
    const dayDate = day.date.toZonedDateTimeISO(timeZone)
    return (
      dayDate.year === date.year &&
      dayDate.month === date.month &&
      dayDate.day === date.day
    )
  })
}

export const openHours = {
  // 08:00
  from: { hour: 8, minute: 0, timeZone },
  // 16:00
  to: { hour: 16, minute: 0, timeZone }
}
